module.exports = __webpack_public_path__ + "static/img/s5.7507dc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zh-TW/s5.png
// module id = soXA
// module chunks = 1